module.exports = __webpack_public_path__ + "media/images/writer/monitor/pc-balloon@3x-953fa7acc5c0738b3d9c21dd2c901bc9.png";